import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import trackPageView from '../../assistants/trackPageView';

// Csak a ténylegesen nyilvános (bejelentkezés nélkül elérhető) oldalakat mérjük -
// ugyanaz a lista, mint amit a grifffrontend/public/robots.txt Allow-listája enged.
const PUBLIC_PATHS = ['/', '/home', '/esemenyek', '/tudasbazis'];

// A Tudás bázis cikkoldalak /tudasbazis/<slug> alakúak, változó slug-gal - ezeket
// előtag-egyezéssel mérjük, nem a fix PUBLIC_PATHS listával.
function isPublicPath(pathname) {
    return PUBLIC_PATHS.includes(pathname) || pathname.startsWith('/tudasbazis/');
}

function PageViewTracker() {
    const location = useLocation();

    useEffect(() => {
        if (isPublicPath(location.pathname)) {
            trackPageView(location.pathname);
        }
    }, [location.pathname]);

    return null;
}

export default PageViewTracker;
